import styled, { css } from 'styled-components';
import { Tag as tag } from 'antd';

const Component = styled(tag)`
  ${props =>
    props.isEllipsis &&
    css`
      white-space: nowrap;
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

const Tag = ({ isEllipsis, ...props }) => <Component {...props} />;
/** @component */
export default Tag;
